module.exports = __webpack_public_path__ + "img/whatsapp.03d1130f.svg";